import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _getBlogQuotasRequest = {};
var _getBlogQuotasResponse = {};
var _getCurrentPermissionsRequest = {};
var _getCurrentPermissionsResponse = {};
var _getImportInformationRequest = {};
var _getImportInformationResponse = {};
var _getImportStatusRequest = {};
var _getImportStatusResponse = {};
var _getMembersScopesMapRequest = {};
var _getMembersScopesMapResponse = {};
var _getMembersScopesRequest = {};
var _getMembersScopesResponse = {};
var _isPermittedRequest = {};
var _isPermittedResponse = {};
var _startImportRequest = {};
var _startImportResponse = {};
function resolveComWixpressNpmCommunitiesPlatformizedBlogV3BlogQuotasServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/communities-blog-node-api',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v3/posts',
                destPath: '/v3/posts',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v2/stats',
                destPath: '/v2/stats',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v3/posts',
                destPath: '/v3/posts',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v2/stats',
                destPath: '/v2/stats',
            },
        ],
        _: [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
            {
                srcPath: '/_api/communities-blog-node-api/_api/blogs/this',
                destPath: '/_api/blogs/this',
            },
            {
                srcPath: '/_api/communities-blog-node-api/_api/categories',
                destPath: '/_api/categories',
            },
            {
                srcPath: '/_api/communities-blog-node-api/_api/site-properties',
                destPath: '/_api/site-properties',
            },
            {
                srcPath: '/_api/communities-blog-node-api/_api/posts/content',
                destPath: '/_api/posts/content',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v3/posts',
                destPath: '/v3/posts',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v2/stats',
                destPath: '/v2/stats',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        '*.pub.wix-code.com': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'social-blog._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'dev._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/blog/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/blog/v3',
                destPath: '/v3',
            },
            {
                srcPath: '/v2/stats',
                destPath: '/v2/stats',
            },
            {
                srcPath: '/v3/posts',
                destPath: '/v3/posts',
            },
            {
                srcPath: '/blog/v3/posts',
                destPath: '/v3/posts',
            },
            {
                srcPath: '/blog/v2/stats',
                destPath: '/v2/stats',
            },
            {
                srcPath: '/_api/v3/posts',
                destPath: '/v3/posts',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressNpmCommunitiesPlatformizedBlogV3BlogDataImportServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/communities-blog-node-api',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v3/posts',
                destPath: '/v3/posts',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v2/stats',
                destPath: '/v2/stats',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v3/posts',
                destPath: '/v3/posts',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v2/stats',
                destPath: '/v2/stats',
            },
        ],
        _: [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
            {
                srcPath: '/_api/communities-blog-node-api/_api/blogs/this',
                destPath: '/_api/blogs/this',
            },
            {
                srcPath: '/_api/communities-blog-node-api/_api/categories',
                destPath: '/_api/categories',
            },
            {
                srcPath: '/_api/communities-blog-node-api/_api/site-properties',
                destPath: '/_api/site-properties',
            },
            {
                srcPath: '/_api/communities-blog-node-api/_api/posts/content',
                destPath: '/_api/posts/content',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v3/posts',
                destPath: '/v3/posts',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v2/stats',
                destPath: '/v2/stats',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        '*.pub.wix-code.com': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'social-blog._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'dev._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/blog/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/blog/v3',
                destPath: '/v3',
            },
            {
                srcPath: '/v2/stats',
                destPath: '/v2/stats',
            },
            {
                srcPath: '/v3/posts',
                destPath: '/v3/posts',
            },
            {
                srcPath: '/blog/v3/posts',
                destPath: '/v3/posts',
            },
            {
                srcPath: '/blog/v2/stats',
                destPath: '/v2/stats',
            },
            {
                srcPath: '/_api/v3/posts',
                destPath: '/v3/posts',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressNpmCommunitiesPlatformizedBlogV3PermissionsServiceUrl(opts) {
    var domainToMappings = {
        _: [
            {
                srcPath: '/_api/blog-permissions',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/blog-permissions',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/blog-permissions',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/blog-permissions',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/blog-permissions',
                destPath: '',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/blog-permissions',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/blog-permissions',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Retrieves current user permissions. */
export function getCurrentPermissions(payload) {
    var _a = serializer(_getCurrentPermissionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getCurrentPermissionsResponse, {}).fromJSON;
    function __getCurrentPermissions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.blog',
            method: 'GET',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.PermissionsService.GetCurrentPermissions',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3PermissionsServiceUrl({ protoPath: '/v3/current-permissions', data: serializedData, host: host }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getCurrentPermissions.fromReq = fromReq;
    __getCurrentPermissions.__isAmbassador = true;
    return __getCurrentPermissions;
}
/** Retrieves members scopes. */
export function getMembersScopes(payload) {
    var _a = serializer(_getMembersScopesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getMembersScopesResponse, {}).fromJSON;
    function __getMembersScopes(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.blog',
            method: 'GET',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.PermissionsService.GetMembersScopes',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3PermissionsServiceUrl({ protoPath: '/v3/members-scopes', data: serializedData, host: host }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getMembersScopes.fromReq = fromReq;
    __getMembersScopes.__isAmbassador = true;
    return __getMembersScopes;
}
/** Retrieves members scopes map. */
export function getMembersScopesMap(payload) {
    var _a = serializer(_getMembersScopesMapRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getMembersScopesMapResponse, {}).fromJSON;
    function __getMembersScopesMap(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.blog',
            method: 'GET',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.PermissionsService.GetMembersScopesMap',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3PermissionsServiceUrl({ protoPath: '/v3/members-scopes-map', data: serializedData, host: host }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getMembersScopesMap.fromReq = fromReq;
    __getMembersScopesMap.__isAmbassador = true;
    return __getMembersScopesMap;
}
/** Checks if the current user has a specified permission. Works for site members as well. */
export function isPermitted(payload) {
    var _a = serializer(_isPermittedRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_isPermittedResponse, {}).fromJSON;
    function __isPermitted(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.blog',
            method: 'GET',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.PermissionsService.IsPermitted',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3PermissionsServiceUrl({ protoPath: '/v3/is-permitted', data: serializedData, host: host }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __isPermitted.fromReq = fromReq;
    __isPermitted.__isAmbassador = true;
    return __isPermitted;
}
/** Imports posts, categories and tags from some wix blog to the current one. */
export function startImport(payload) {
    var _a = serializer(_startImportRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_startImportResponse, {}).fromJSON;
    function __startImport(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.blog',
            method: 'POST',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.BlogDataImportService.StartImport',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3BlogDataImportServiceUrl({
                protoPath: '/v3/import/{sourceInstanceId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __startImport.fromReq = fromReq;
    __startImport.__isAmbassador = true;
    return __startImport;
}
/** Returns information about entities which are able for import from source blog. */
export function getImportInformation(payload) {
    var _a = serializer(_getImportInformationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getImportInformationResponse, {}).fromJSON;
    function __getImportInformation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.blog',
            method: 'GET',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.BlogDataImportService.GetImportInformation',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3BlogDataImportServiceUrl({
                protoPath: '/v3/import/information/{sourceInstanceId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getImportInformation.fromReq = fromReq;
    __getImportInformation.__isAmbassador = true;
    return __getImportInformation;
}
/** Returns information about import status. */
export function getImportStatus(payload) {
    var _a = serializer(_getImportStatusRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getImportStatusResponse, {}).fromJSON;
    function __getImportStatus(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.blog',
            method: 'GET',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.BlogDataImportService.GetImportStatus',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3BlogDataImportServiceUrl({ protoPath: '/v3/import/status', data: serializedData, host: host }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getImportStatus.fromReq = fromReq;
    __getImportStatus.__isAmbassador = true;
    return __getImportStatus;
}
/** Returns quotas for post, category, tag entities for given blog. */
export function getBlogQuotas(payload) {
    var _a = serializer(_getBlogQuotasRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getBlogQuotasResponse, {}).fromJSON;
    function __getBlogQuotas(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.blog',
            method: 'GET',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.BlogQuotasService.GetBlogQuotas',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3BlogQuotasServiceUrl({ protoPath: '/v3/quotas', data: serializedData, host: host }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3BlogQuotasServiceUrl({ protoPath: '/v3/quotas', data: serializedData, host: host }),
                    params: toURLSearchParams(serializedData),
                },
            ],
        };
        return metadata;
    }
    __getBlogQuotas.fromReq = fromReq;
    __getBlogQuotas.__isAmbassador = true;
    return __getBlogQuotas;
}
//# sourceMappingURL=http.impl.js.map